import React from "react";
import { Reveal, Stagger, staggerItem } from "./motion/Reveal";
import { motion } from "framer-motion";
import SacredOrnament from "./SacredOrnament";

const THEMES = [
    "Espiritualidad y energía",
    "Crecimiento y mentalidad",
    "Ángeles y seres de luz",
    "Rituales y trabajos con velas",
    "Meditación y manifestación",
    "Sanación emocional",
];

export default function Essence() {
    return (
        <section id="esencia" className="relative py-20 sm:py-28 bg-alma-white">
            <div className="max-w-[900px] mx-auto px-6 sm:px-8 text-center">
                <Reveal>
                    <SacredOrnament className="h-5 w-40 mx-auto mb-8" color="#C9A24B" />
                    <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] text-alma-ink">
                        Una familia,
                        <span className="italic text-alma-goldDeep"> un hogar para tu alma.</span>
                    </h2>
                    <p className="mt-7 font-sans text-lg text-alma-slate leading-relaxed">
                        Un espacio íntimo, cercano y humano donde compartir lo que estás viviendo
                        sin sentirte sola, extraña ni juzgada. Aquí encuentras acompañamiento,
                        reflexiones y recursos para caminar tu espiritualidad cada día.
                    </p>
                </Reveal>

                <Stagger className="mt-10 flex flex-wrap justify-center gap-2.5" stagger={0.06}>
                    {THEMES.map((t, i) => (
                        <motion.span
                            key={i}
                            variants={staggerItem}
                            className="rounded-full border border-alma-mist bg-alma-ivory px-4 py-2 text-sm text-alma-ink"
                        >
                            {t}
                        </motion.span>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
